import React, { Fragment } from "react";
import { ImagePicker } from "react-file-picker";
import UploadIcon from "../../../assets/images/upload.svg";
import ValidationMessage from "../../../services/ValidationMessage";
import { ReactComponent as CrossIcon } from "../../../assets/icons/cross_circle.svg";
import "./image_picker.scss";

export default function CustomImagePicker(props) {
  const { name, validation, value, photoName, removeHandler } = props;
  return (
    <Fragment>
      <ImagePicker
        extensions={["jpg", "jpeg", "png"]}
        dims={{ minWidth: 10, minHeight: 10 }}
        {...props}
      >
        {
          <button className="upload-image-container">
            {value ? (
              <img
                src={value}
                className="uploaded-image"
                alt="uploaded image"
              />
            ) : (
              <Fragment>
                <img
                  src={UploadIcon}
                  className="upload-image-icon"
                  alt="upload image"
                />
                <br />
                {photoName}
                {validation ? (
                  <span
                    className="text-danger"
                    style={{
                      fontSize: "1rem",
                    }}
                  >
                    *
                  </span>
                ) : (
                  ""
                )}
              </Fragment>
            )}
          </button>
        }
      </ImagePicker>
      {validation ? (
        <ValidationMessage name={name} fallbackErrorElement={<span></span>} />
      ) : (
        ""
      )}
      {removeHandler && value && (
        <i
          className="upload-image-remover cursor-pointer"
          onClick={removeHandler}
        >
          <CrossIcon />
        </i>
      )}
      <ul className="upload-image-instruction">
        <li>Should not be greater than 2Mb</li>
        <li>Supported File .jpg, .jpeg, .png,</li>
      </ul>
    </Fragment>
  );
}
